import "./Modal.Layout.scss"
interface Props {
    children: React.ReactNode
    className?: string
}
export function ModalHeader(props:Props) {
    return <div className={"ModalHeader flex justify-between items-center" + props.className}>{props.children}</div>
}